export default __webpack_public_path__ + "youtube-hrz-v1.svg";